import React from 'react';
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter, Heart } from 'lucide-react';
import { clinicInfo } from '../mock';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">{clinicInfo.name}</h3>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Your trusted partner in dental care, committed to delivering exceptional service and beautiful smiles since 2008.
            </p>
            <div className="flex gap-4">
              <a 
                href={clinicInfo.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-3 rounded-full hover:bg-emerald-600 transition-colors"
              >
                <Facebook size={20} />
              </a>
              <a 
                href={clinicInfo.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-3 rounded-full hover:bg-emerald-600 transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a 
                href={clinicInfo.socialMedia.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-3 rounded-full hover:bg-emerald-600 transition-colors"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'About', 'Services', 'Gallery', 'Testimonials', 'Contact'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(item.toLowerCase())}
                    className="hover:text-emerald-400 transition-colors"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xl font-bold text-white mb-4">Our Services</h4>
            <ul className="space-y-3">
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Aligners & Braces</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Dental Implants</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Laser Root Canals</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Veneers & Laminates</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Teeth Whitening</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Full Mouth Rehabilitation</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold text-white mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-emerald-500 flex-shrink-0 mt-1" />
                <span className="text-gray-400">{clinicInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-emerald-500 flex-shrink-0" />
                <a href={`tel:${clinicInfo.phone}`} className="text-gray-400 hover:text-emerald-400 transition-colors">
                  {clinicInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-emerald-500 flex-shrink-0" />
                <a href={`mailto:${clinicInfo.email}`} className="text-gray-400 hover:text-emerald-400 transition-colors">
                  {clinicInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© 2024 {clinicInfo.name}. All rights reserved.</p>
            <p className="flex items-center gap-2">
              Made with <Heart size={16} fill="#ef4444" stroke="#ef4444" /> for healthier smiles
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
